export default __webpack_public_path__ + "static/media/ApolloBanner.bd3d3642.svg";